<div class="user-queue-user-entry">
    <div class="user-queue-display">
        <div class="user-queue-ups-id">
            @if (user.isEditing) {
<label class="form-label">{{localize(langSection.Term, langText.UpsId)}}</label>
}
            <div class="preserve-white-space {{user.isEditing ? 'readonly-ups-id' : ''}}">{{user.upsId}}</div>
        </div>
        <div class="large-column">
            @if (!emailIsValid && !user.isEditing) {
<div class="d-flex justify-content-end">
                <span class="error-message">{{this.localize(this.langSection.AddUserPage, this.langText.EmailInvalid)}}</span>
            </div>
}
            <div [ngClass]="emailIsValid || user.isEditing ? '' : 'error'">
                @if (!user.isEditing) {
<span class="user-queue-email">{{user.email}}</span>
}
                <div class="d-flex justify-content-between align-items-baseline">
                    @if (user.isEditing) {
<label class="form-label">{{localize(langSection.Term, langText.Email)}} *</label>
}
                    @if (!emailIsValid && user.isEditing) {
<span class="error-message">{{this.localize(this.langSection.AddUserPage, this.langText.EmailInvalid)}}</span>
}
                </div>
                @if (user.isEditing) {
<input (input)="validateEmail($event.target.value)" class="form-control {{!emailIsValid ? 'error': ''}}"  type="text" [(ngModel)]="emailEdit" />
}
            </div>
        </div>
        <div class="role">
            @if (!roleIsValid && !user.isEditing) {
<div class="d-flex justify-content-end">
                <span class="error-message">{{this.localize(this.langSection.AddUserPage, this.langText.RoleInvalid)}}</span>
            </div>
}
            <div [ngClass]="roleIsValid || user.isEditing ? '' : 'error'">
                @if (!user.isEditing) {
<span>{{roleDisplay(user.role)}}</span>
}
                <div class="d-flex justify-content-between align-items-baseline">
                    @if (user.isEditing) {
<label class="form-label">{{localize(langSection.Term, langText.Role)}}</label>
}
                    @if (!roleIsValid && user.isEditing) {
<span class="error-message">{{this.localize(this.langSection.AddUserPage, this.langText.RoleInvalid)}}</span>
}
                </div>
                @if (user.isEditing) {
<select (change)="validateRole($event)" class="form-select {{!roleIsValid ? 'error': ''}}" [(ngModel)]="roleEdit" ngDefaultControl>
                    @for (role of roles; track role) {
<option [value]="role.value">
                        {{role.display}}
                    </option>
}
                </select>
}
            </div>
        </div>
        @if (!user.isEditing) {
<div class="user-queue-icons">
            <div class="ups-icon ups-icon-edit" (click)="edit()"></div>
            <div class="ups-icon ups-icon-x" (click)="delete()"></div>
        </div>
}
    </div>
    @if (user.isEditing) {
<div class="button-section">
        <button class="btn-white" (click)="delete()">{{localize(langSection.AddUserPage, langText.DeleteUser)}}</button>
        <div>
            <a class="cancel-link" href="#" (click)="cancel($event); $event.preventDefault()">{{localize(langSection.Term, langText.Cancel)}}</a>
            <button [disabled]="!enableConfirm" (click)="updateUser()">{{localize(langSection.Term, langText.Confirm)}}</button>
        </div>
    </div>
}
</div>